// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../common.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
exports.push([module.id, "._1jrrZoHmx{flex-direction:column;justify-content:center;flex-grow:1;text-align:center;padding:20px}._4gjx7INTx{align-items:center}._6PdViLEVx{justify-content:center}.arGVocnRx{}._57jsMi8xx{flex:0 0 100%}._1CDS1fEdx{align-items:stretch}._1jrrZoHmx{}._4NNqW8xsx{position:relative}._4NNqW8xsx .asjc1kyix{position:absolute;left:calc(50% - 98px/2);top:21px;height:159px;width:98px}._5biSdgKXx{margin-top:20px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"container": "_1jrrZoHmx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["container"] + "",
	"vertically-center": "_4gjx7INTx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"verticallyCenter": "_4gjx7INTx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"horizontally-center": "_6PdViLEVx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"horizontallyCenter": "_6PdViLEVx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"centered": "arGVocnRx _4gjx7INTx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + " _6PdViLEVx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"full-flex-basis": "_57jsMi8xx",
	"fullFlexBasis": "_57jsMi8xx",
	"flex-stretch": "_1CDS1fEdx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"flexStretch": "_1CDS1fEdx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"register-animation-container": "_4NNqW8xsx",
	"registerAnimationContainer": "_4NNqW8xsx",
	"register-animation": "asjc1kyix",
	"registerAnimation": "asjc1kyix",
	"do-later": "_5biSdgKXx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["standalone-anchor"] + "",
	"doLater": "_5biSdgKXx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["standalone-anchor"] + ""
};
module.exports = exports;
